document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.getElementById('pdp-register-nudge');
  if (!dialog) return;
  const inDesignMode = window.Shopify?.designMode;
  const showInDesignMode = dialog.dataset.showInDesignMode === 'true';
  if (inDesignMode && !showInDesignMode) return;

  const delay = inDesignMode ? 0 : parseInt(dialog.dataset.delay, 10) || 45000;
  const freqDays = parseInt(dialog.dataset.frequency, 10) || 14;

  const seen = document.cookie
    .split('; ')
    .find((row) => row.startsWith('seen_pdp_register_nudge='))
    ?.split('=')[1];
  if (inDesignMode || !seen) {
    window.addEventListener(
      'load',
      () => {
        dialog.querySelectorAll('img[loading="lazy"]').forEach((image) => {
          image.loading = 'eager';
        });
      },
      { once: true }
    );

    setTimeout(() => {
      dialog.showModal();
      dialog.focus();
    }, delay);
  }

  // Suppress the nudge for the frequency window once the guest has seen or acted on it
  const markSeen = () => {
    if (inDesignMode) return;
    const expiry = new Date(Date.now() + freqDays * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `seen_pdp_register_nudge=true; expires=${expiry}; path=/; SameSite=Lax`;
  };

  const closeButton = dialog.querySelector('#pdp-register-nudge-close');
  closeButton.addEventListener('click', () => {
    dialog.close();
  });

  dialog.addEventListener('close', markSeen);
  dialog.querySelectorAll('.pdp-register-nudge__cta').forEach((cta) => {
    cta.addEventListener('click', markSeen);
  });
});
